export const SITE_PAGE_FORM_ITEM_SIZE: string = "form-group col-md-4 col-sm-6 col-xs-12";
export const SITE_PAGE_FORM_WIDE_SIZE: string = "form-group col-md-12 col-sm-6 col-xs-12";
export const SITE_FORM_LARGE_BOX_SIZE: string = "form-group col-md-16 col-sm-6 col-xs-12";
export const SITE_PAGE_FORM_ACTION_BUTTON_SIZE: string = "form-group col-md-2 col-sm-4 col-xs-4";

export const SITE_PAGE_FORM_ACTION_BUTTON_SIZE_3: string = "form-group col-md-3 col-sm-6 col-xs-6";
export const SITE_PAGE_FORM_ACTION_BUTTON_SIZE_2: string = "form-group col-md-2 col-sm-6 col-xs-6";
